import React from "react";

export const CloseIcon = ({ ...props }) => {
  return (
    <svg width={31} height={31} viewBox="0 0 31 31" fill="none" {...props}>
      <rect width={31} height={31} rx={8} fill="#01A8CE" cursor="pointer" />
      <path
        d="M12.281 12.281l6.187 6.188M12.281 18.469l6.187-6.188"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
